import type {
  CmmdRuntimeInventoryThreadSummary,
  CmmdRuntimeThreadLifecycle,
} from "@cmmd-forge/contracts";

/** Project CMMD's canonical disposition onto the existing sidebar row model. */
export function resolveInventoryThreadLifecycle(
  thread: Pick<CmmdRuntimeInventoryThreadSummary, "disposition">,
): CmmdRuntimeThreadLifecycle {
  return thread.disposition.effectiveDisposition === "settled"
    ? { settledAt: null, settledOverride: "settled" }
    : { settledAt: null, settledOverride: "active" };
}
